import { createRouter, createWebHistory } from 'vue-router'
import { useCoin2CoreStore } from '../stores/coin2core';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('@/views/Login.vue'),
    },    
    {
      path: '/wallet',
      name: 'wallet',
      component: () => import('@/views/Dashboard.vue'),
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/Profile.vue'),
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/Register.vue'),
    },
    {
      path: '/passwordchange',
      name: 'passwordChange',
      component: () => import('@/views/PasswordChange.vue'),
    },
    {
      path: '/forgotpassword',
      name: 'forgotPassword',
      component: () => import('@/views/ForgotPassword.vue'),
    },
    {
      path: '/resetpassword',
      name: 'resetPassword',
      component: () => import('@/views/ResetPassword.vue'),
    },
    {
      path: '/transact',
      name: 'transact',
      component: () => import('@/views/Payments.vue'),
    },
    {
      path: '/exchange',
      name: 'exchange',
      component: () => import('@/views/Exchange.vue')
    }
  ]
})

router.beforeEach((to) => {  
  const store = useCoin2CoreStore();  

  if(!store.loginId && (to.name !== 'login' && to.name !== 'register' && to.name !== 'forgotPassword' && to.name !== 'resetPassword')) {    
    return { name: 'login'};
  }  
})
export default router
